export const BUSINESS_ERROR_CODES_CLI = {
    Decline: '600020',
    Referral: '600019',
    'Invalid Internal Status': '610003',
    'Invalid External Status': '610004',
    'Requested limit lesser than current credit line': '600001'
};
export const BUSINESS_ERROR_STATUS_CODE = 422;
